import React, { useState } from 'react';
import {
  Badge,
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Popover,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { NotificationsOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { useNotifications } from '@/hooks/useNotifications';
import AdminNotificationsTab from '@/components/Notifications/Tabs/AdminNotificationsTab';
import ReservationNotificationsTab from '@/components/Notifications/Tabs/ReservationNotificationsTab';

const NotificationsButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { hasUnread, loadNotifications, markAsRead } = useNotifications();
  const { t } = useTranslation();

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
    if (hasUnread) markAsRead();
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size="large" aria-label={t('notifications.label')} onClick={handleOpen}>
        <Badge color="error" variant="dot" invisible={!hasUnread}>
          <NotificationsOutlined />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              width: { xs: '90vw', sm: 420 },
              maxHeight: '70vh',
              display: 'flex',
              flexDirection: 'column',
              mt: 1,
            },
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ px: 2, py: 1.5, fontWeight: 600 }}>
          {t('notifications.title')}
        </Typography>
        <Divider />
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
        >
          <Tab label={t('notifications.tabs.admin')} />
        </Tabs>
        <Divider />
        <Box sx={{ overflowY: 'auto', flex: 1 }}>
          {activeTab === 0 && <AdminNotificationsTab open={open} />}
        </Box>
      </Popover>
    </>
  );
};

export default NotificationsButton;
